import React, { useState } from 'react';
import Viewer from 'react-viewer';
import { toast } from 'react-toastify';
import * as AuthService from '../../../services/auth.ts';
import {
  Card,
  Table,
  Button,
  Form,
  Badge,
  Row,
  Col,
  Modal
} from 'react-bootstrap';

const TableCheckRegistration = ({ show, items = [], onRefresh }) => {
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);

  // ควบคุมการเปิดดูรูปแบบซูมได้
  const [viewerVisible, setViewerVisible] = useState(false);
  const [viewerImages, setViewerImages] = useState([{ src: '', alt: '' }]);

  // 💡 1. เพิ่ม State สำหรับเก็บคำค้นหา
  const [searchTerm, setSearchTerm] = useState('');

  // 💡 2. ทำการกรองข้อมูลจากคำค้นหา (ค้นหาจาก ทะเบียน หรือ รหัสพนักงาน)
  const filteredItems = items.filter((item) => {
    const searchLower = searchTerm.toLowerCase().trim();
    if (searchLower === '') return true; // ถ้าไม่ได้พิมพ์อะไร ให้โชว์ทั้งหมด

    const matchRegisNumber = item.RegisNumber ? item.RegisNumber.toLowerCase().includes(searchLower) : false;
    const matchStaffId = item.StaffId ? item.StaffId.toLowerCase().includes(searchLower) : false;

    return matchRegisNumber || matchStaffId;
  });

  // อนุมัติหรือปฏิเสธรถส่วนตัวพนักงาน
  const handleAction = async (status) => {
    if (!selectedCar) return;
    
    let remarkInput = '';

    try {
      // 💡 1. เงื่อนไขกรณีกด "ปฏิเสธ" (สถานะ F) ให้เด้งกล่องข้อความให้กรอกเหตุผล
      if (status === 'F') {
        const reason = window.prompt('❌ กรุณาระบุเหตุผลในการปฏิเสธคำขอนี้:');
        
        // ถ้าผู้ใช้กด Cancel หรือไม่ได้กรอกอะไรเลย ให้หยุดการทำงานไม่ส่งไปหลังบ้าน
        if (reason === null) return; 
        if (reason.trim() === '') {
          toast.warning('จำเป็นต้องระบุเหตุผลในการปฏิเสธครับ');
          return;
        }
        remarkInput = reason; // เก็บเหตุผลที่กรอกไว้ส่งไปหลังบ้าน
      } else {
        // กรณีอนุมัติ (สถานะ A) ใช้การ Confirm ปกติ
        if (!window.confirm('ยืนยันการอนุมัติใช่หรือไม่?')) return;
      }

      // 💡 2. ส่งค่า selectedCar.VehicleId, สถานะ และ เหตุผล (remarkInput) ไปที่ API
      const result = await AuthService.updateVehicleStatus(selectedCar.VehicleId, status, remarkInput);
      
      if (result.success) {
        toast.success(status === 'A' ? 'อนุมัติการลงทะเบียนรถเรียบร้อยแล้ว' : 'ปฏิเสธคำขอและบันทึกเหตุผลเรียบร้อยแล้ว');
        setShowViewModal(false);
        if (onRefresh) onRefresh();
      } else {
        toast.error(result.error || 'เกิดข้อผิดพลาด');
      }
    } catch (error) {
      console.error("เกิดปัญหาตอนกดจัดการสถานะรถ:", error);
      toast.error('ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้');
    }
  };

  return (
    <div className="col-12">
      <Card className="card-outline card-primary shadow-sm">
        <div className={show ? 'd-none' : 'overlay dark'}>
          <span style={{ color: 'white', fontSize: 30, fontWeight: 'bold' }}>
            CR ONLY
          </span>
        </div>

        <Card.Body>
          {/* Header & Filter Area */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4 className="m-0" style={{ fontWeight: 700, color: '#333' }}>
              รายการตรวจสอบการลงทะเบียน
            </h4>
            <div className="d-flex gap-2">
              {/* 💡 3. ผูกช่องค้นหากับ State searchTerm */}
              <Form.Control
                type="text"
                placeholder="🔍 ค้นหาทะเบียน / รหัสพนักงาน..."
                className="shadow-sm mx-2"
                style={{ width: '280px', borderRadius: '8px' }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              
              {/* 💡 4. เอาตัว Dropdown สถานะออกเรียบร้อยแล้ว และปรับปุ่มเป็นปุ่มรีเฟรชข้อมูลกลางแทน เพื่อความสะดวก */}
              <Button
                variant="outline-secondary"
                className="mx-2 shadow-sm"
                style={{ borderRadius: '8px' }}
                onClick={() => {
                  setSearchTerm('');
                  if (onRefresh) onRefresh();
                }}
              >
                <i className="fas fa-sync-alt"></i> รีเฟรช
              </Button>
            </div>
          </div>

          {/* --- 💡 5. เปลี่ยนมาเช็กและลูปข้อมูลจากก้อน filteredItems แทน --- */}
          {filteredItems && filteredItems.length > 0 ? (
            <div className="table-responsive">
              <Table
                borderless
                hover
                className="align-middle"
                style={{ fontSize: '15px' }}
              >
                <thead
                  style={{
                    backgroundColor: '#f8f9fa',
                    borderBottom: '2px solid #eee'
                  }}
                >
                  <tr>
                    <th className="py-3 px-4">ไอดีรถ</th>
                    <th className="py-3">ข้อมูลพนักงาน</th>
                    <th className="py-3">รายละเอียดรถ</th>
                    <th className="py-3">จังหวัด</th>
                    <th className="py-3 text-center">สถานะ</th>
                    <th className="py-3 text-center">จัดการ</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItems.map((item) => (
                    <tr
                      key={item.VehicleId}
                      style={{ borderBottom: '1px solid #f1f1f1' }}
                    >
                      <td className="px-4 text-muted">#{item.VehicleId}</td>
                      <td>
                        <div style={{ fontWeight: 600, fontSize: '16px' }}>
                          พนักงานรหัส: {item.StaffId}
                        </div>
                        <span className="text-secondary">
                          ID: {item.StaffId}
                        </span>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          <img
                            src={item.Url}
                            alt="car"
                            className="rounded shadow-sm me-3"
                            style={{
                              width: '70px',
                              height: '70px',
                              objectFit: 'cover'
                            }}
                          />
                          <div className="mx-2">
                            <div
                              style={{
                                fontWeight: 700,
                                fontSize: '14px',
                                color: '#007bff'
                              }}
                            >
                              {item.RegisNumber}
                            </div>
                            <span className="text-muted">
                              {item.BrandModel} ({item.EngineCC} cc)
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <span className="badge bg-light text-dark border p-2" style={{
                            fontSize: '13px',
                            borderRadius: '20px',
                          }}>
                          {item.ProvinceNameTH}
                        </span>
                      </td>
                      <td className="text-center">
                        <Badge
                          bg="warning"
                          className="p-2 px-3"
                          style={{
                            fontSize: '13px',
                            borderRadius: '20px',
                            color: '#856404',
                            backgroundColor: '#fff3cd'
                          }}
                        >
                          {item.VehicleStatus === 'P' ? 'รอตรวจสอบ' : item.VehicleStatus}
                        </Badge>
                      </td>
                      <td className="text-center">
                        <Button
                          variant="info"
                          className="text-white shadow-sm"
                          style={{
                            borderRadius: '8px',
                            padding: '5px 15px',
                            fontWeight: 600
                          }}
                          onClick={() => {
                            setSelectedCar(item);
                            setShowViewModal(true);
                          }}
                        >
                          <i className="fas fa-search me-1"></i> ตรวจสอบ
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            // --- ส่วนของ Empty State ---
            <div
              className="text-center py-5"
              style={{
                backgroundColor: '#fcfcfc',
                borderRadius: '15px',
                border: '2px dashed #eee'
              }}
            >
              <div className="mb-3">
                <i
                  className="fas fa-clipboard-check"
                  style={{ fontSize: '60px', color: '#dee2e6' }}
                ></i>
              </div>
              <h5 className="text-secondary" style={{ fontWeight: 600 }}>
                {searchTerm ? 'ไม่พบข้อมูลที่ตรงกับคำค้นหา' : 'ไม่พบรายการที่รอตรวจสอบ'}
              </h5>
              <p className="text-muted">
                {searchTerm ? 'ตรวจสอบตัวสะกด หรือลองเปลี่ยนคำค้นหาใหม่อีกครั้ง' : 'ในขณะนี้ยังไม่มีพนักงานส่งคำขอลงทะเบียนรถเข้ามาใหม่'}
              </p>
              <Button
                variant="outline-primary"
                size="sm"
                onClick={() => {
                  setSearchTerm('');
                  if (onRefresh) onRefresh();
                }}
                style={{ borderRadius: '20px', padding: '5px 20px' }}
              >
                <i className="fas fa-sync-alt me-2"></i> รีเฟรชข้อมูล
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>

      {/* --- Upgrade Modal Design --- */}
      <Modal
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        size="xl"
        centered
        borderless
        className="shadow"
      >
        <Modal.Header
          closeButton
          style={{ borderBottom: 'none', padding: '25px 30px' }}
        >
          <Modal.Title style={{ fontWeight: 800, fontSize: '24px' }}>
            🔎 ตรวจสอบทะเบียน:{' '}
            <span className="text-primary">{selectedCar?.RegisNumber}</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '0 30px 30px 30px' }}>
          {selectedCar && (
            <Row className="g-4">
              <Col md={5}>
                <div
                  className="p-3 rounded-4"
                  style={{ backgroundColor: '#f8f9fa' }}
                >
                  <h5
                    className="mb-3"
                    style={{ fontWeight: 700, fontSize: '16px', color: '#555' }}
                  >
                    ข้อมูลทางเทคนิค
                  </h5>
                  {[
                    {
                      label: 'ยี่ห้อ / รุ่น',
                      value: selectedCar.BrandModel
                    },
                    { label: 'ประเภทรถ', value: selectedCar.VehicleTypeName },
                    { label: 'ความจุเครื่องยนต์', value: `${selectedCar.EngineCC} cc` },
                    { label: 'ประเภทเชื้อเพลิง', value: selectedCar.FuelTypeName },
                    {
                      label: 'ทะเบียน / จังหวัด',
                      value: `${selectedCar.RegisNumber} - ${selectedCar.ProvinceNameTH}`,
                      highlight: true
                    }
                  ].map((info, i) => (
                    <div
                      key={i}
                      className="d-flex justify-content-between mb-2 pb-2"
                      style={{ borderBottom: '1px dashed #ddd' }}
                    >
                      <span className="text-muted">{info.label}</span>
                      <span
                        style={{
                          fontWeight: 600,
                          color: info.highlight ? '#007bff' : '#333'
                        }}
                      >
                        {info.value}
                      </span>
                    </div>
                  ))}
                </div>
              </Col>
              <Col md={7}>
                <h5
                  className="mb-3"
                  style={{ fontWeight: 700, fontSize: '16px', color: '#555' }}
                >
                  หลักฐานรูปถ่าย
                </h5>
                <Row className="g-2">
                  <Col xs={6}>
                    <div className="text-center">
                      <small className="d-block mb-1 text-muted">
                        รูปรถจริง
                      </small>
                      <img
                        src={selectedCar.Url}
                        className="img-fluid rounded shadow-sm border"
                        alt="Car"
                        style={{ cursor: 'pointer', maxHeight: '200px', width: '100%', objectFit: 'cover' }}
                        onClick={() => {
                          setViewerImages([{ src: selectedCar.Url, alt: 'รูปรถจริง' }]);
                          setViewerVisible(true);
                        }}
                      />
                    </div>
                  </Col>
                  <Col xs={6}>
                    <div className="text-center">
                      <small className="d-block mb-1 text-muted">
                        เล่มทะเบียน
                      </small>
                      <img
                        src={selectedCar.Url2}
                        className="img-fluid rounded shadow-sm border"
                        alt="Book"
                        style={{ cursor: 'pointer', maxHeight: '200px', width: '100%', objectFit: 'cover' }}
                        onClick={() => {
                          setViewerImages([{ src: selectedCar.Url2, alt: 'เล่มทะเบียน' }]);
                          setViewerVisible(true);
                        }}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer style={{ borderTop: 'none', padding: '20px 30px' }}>
          <div className="ms-auto">
            {/* ปุ่มปฏิเสธ (เปลี่ยนเป็นสถานะ F) */}
            <Button
              variant="outline-danger"
              className="me-2 px-4 mx-2"
              style={{ borderRadius: '8px', fontWeight: 600 }}
              onClick={() => handleAction('F')}
            >
              ปฏิเสธ
            </Button>
            
            {/* ปุ่มอนุมัติ (เปลี่ยนเป็นสถานะ A) */}
            <Button
              variant="success"
              className="px-4 shadow"
              style={{ borderRadius: '8px', fontWeight: 600 }}
              onClick={() => handleAction('A')}
            >
              อนุมัติลงทะเบียน
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Viewer
        zoomSpeed={0.2}
        zIndex={9999}
        visible={viewerVisible}
        onClose={() => setViewerVisible(false)}
        images={viewerImages}
      />
    </div>
  );
};

export default TableCheckRegistration;